import { useState } from 'react';
import { toast } from 'sonner';
import { ExpertsTermsAndAgreement } from '../ExpertsTermsAndAgreement';
import { DoctorTermsContent } from './DoctorTermsContent'; // Import the doctor content
import { onboardDoctor } from '../../../../../api/onboardingApis/doctorOnboardingApi/doctorFinalStep.api'; 
import { IS_DEV, TEST_REAL_API } from "@/config/env";

interface DoctorFinalStepProps {
  onSubmit: () => void;
  onBack?: () => void;
}

export default function DoctorFinalStep({ onSubmit }: DoctorFinalStepProps) {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleDoctorSubmit = async () => {
    setIsSubmitting(true);

    try {
      const expertCode = localStorage.getItem('expertCode');
      
      if (!expertCode) {
        toast.error("Session missing. Please login again.");
        setIsSubmitting(false);
        return;
      }

      // 🟢 MOCK LOGIC (If Dev & NOT testing Real API)
      if (IS_DEV && !TEST_REAL_API) {
        await new Promise(resolve => setTimeout(resolve, 1500));
        toast.success("⚡ Mock Submission Successful!");
        onSubmit();
        return;
      }

      // --- REAL API LOGIC ---
      const payload = {
        expertCode,
        isAgreementSigned: true,
        isAcknowledged: true
      };

      await onboardDoctor(payload);

      toast.success("Doctor Profile Created Successfully!");
      onSubmit();

    } catch (error: any) {
      console.error("API Error:", error);
      toast.error(error.response?.data?.message || "Failed to create profile. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <ExpertsTermsAndAgreement
      roleName="Medical Expert"
      onSubmit={handleDoctorSubmit}
      isSubmitting={isSubmitting}
    >
      <DoctorTermsContent />
    </ExpertsTermsAndAgreement>
  );
}